import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagsService } from './feature-flag.service';

@Directive({
  standalone: false,
  selector: '[carShowIfFeatureFlagEnable]'
})
export class FeatureFlagDirective implements OnInit {

  @Input()
  public carShowIfFeatureFlagEnable: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagService: FeatureFlagsService
  ) { }
  
  ngOnInit(): void {
    if (this.featureFlagService.ContainsFeatureFlag(this.carShowIfFeatureFlagEnable)){
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
